"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/faqSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordionActiveFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-item active wow fadeInUp" | "accordion-item wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    div0ClassName: string;
    /** Detected variants: "Our wellness programs are designed for infants, children, adults, and seniors, offering personalized preventive care, routine health assessments, and age-specific wellness guidance." | "We recommend wellness check-ins every few months for infants, transitioning to annual visits for older children. These sessions are essential for tracking health, growth, and necessary vaccinations." | "Yes, you can conveniently schedule online wellness consultations with our healthcare professionals for routine check-ups, health advice, follow-up care, and preventive guidance." | "Yes, we offer a wide range of recommended immunizations as part of our wellness services to protect patients of all ages from preventable diseases through safe, certified vaccination programs year-round." | "Absolutely. Our clinic provides safe and certified vaccination services, following recommended immunization schedules to ensure long-term health and disease prevention for everyone." */
    p0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    id: string;
    /** Detected variants: "What age groups do you cater to in your wellness programs?" | "Is it possible to schedule a consultation online for services?" | "Can I arrange an online appointment for wellness consultations?" | "Does your clinic provide immunizations as part of your wellness services?" | "Are vaccinations available at your wellness clinic?" */
    a0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    a0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" | "#collapseFive" */
    dataBsTarget: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" | "headingFive" */
    h30Id: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName2?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName3?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
};
export type HomeSeventeenFaqSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionActiveFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Your journey to vibrant health and lasting peace begins here." */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "faq-details-one" */
    sectionDiv0Div0Div1Div0Div0DivId?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-bg-03.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-bg-04.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    faqSectionAccordionActiveFadeInUps: FaqSectionAccordionActiveFadeInUpsItem[];
    faqSectionAccordionActiveFadeInUpsItemWrapper?: (item: FaqSectionAccordionActiveFadeInUpsItem, content: ReactNode) => ReactNode;
    faqSectionAccordionActiveFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionActiveFadeInUpsH3Visible?: boolean;
    faqSectionAccordionActiveFadeInUpsH3Renderer?: (item: FaqSectionAccordionActiveFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionActiveFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionActiveFadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeSeventeenFaqSectionGenerated: FC<HomeSeventeenFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H20H2Text = "Your journey to vibrant health and lasting peace begins here.",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0DivId = "faq-details-one",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/faq-bg-03.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/faq-bg-04.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divH30H3Props,
    sectionDiv0Div0ClassName,
    faqSectionAccordionActiveFadeInUps,
    faqSectionAccordionActiveFadeInUpsItemWrapper,
    faqSectionAccordionActiveFadeInUpsRenderer,
    faqSectionAccordionActiveFadeInUpsH3Visible,
    faqSectionAccordionActiveFadeInUpsH3Renderer,
    faqSectionAccordionActiveFadeInUpsH3Props,
}) => {
    return (
        <section className="faq-section-seventeen section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="faq-content wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="faq-info faq-info-seventeen">
                            <div className="accordion" id={sectionDiv0Div0Div1Div0Div0DivId}>
                                {renderCollectionNode(
                                    faqSectionAccordionActiveFadeInUps,
                                    (item: FaqSectionAccordionActiveFadeInUpsItem) => (
                                        <div className={item.className} data-wow-duration={item.dataWowDuration} key={item.key}>
                                            {renderItemNode(faqSectionAccordionActiveFadeInUpsH3Visible, faqSectionAccordionActiveFadeInUpsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionActiveFadeInUpsH3Props === "function" ? faqSectionAccordionActiveFadeInUpsH3Props(item) : (faqSectionAccordionActiveFadeInUpsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    <a href={item.href ?? "#"} className={item.a0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls}>{item.a0Text}</a>
                                                </h3>
                                            ))}
                                            <div id={item.id} className={item.div0ClassName} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                                <div className={item.div0ClassName2 ?? "accordion-body"}>
                                                    <div className={item.div0ClassName3 ?? "accordion-content"}>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    faqSectionAccordionActiveFadeInUpsItemWrapper,
                                    faqSectionAccordionActiveFadeInUpsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="faq-bg-01 img-fluid" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="faq-bg-02 img-fluid" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSeventeenFaqSectionGenerated;
